<template>
  <lay-dropdown trigger="click" updateAtScroll placement="right-top">
    <img v-if="type == 1" class="signal-node" :class="((context?.[nodeTitle]?.status == undefined || context?.[nodeTitle].status == 0) ? 'fa-no-signal' : (context?.[nodeTitle]?.di != 5 ? 'off' : 'on')) + ((context?.[nodeTitle]?.alert == 1) && context?.alert ? ' bling' : '')" draggable="false" :data-title="nodeTitle" :src="context?.[nodeTitle]?.di != 5 ? `images/fa-on${remark ?? ''}.png` : `images/fa-off${remark ?? ''}.png`" data-tip="fa-off 发电机关闭 fa-on 发电机打开" :style="nodeStyle">
    <div  v-else class="signal-node" :class="((context?.[nodeTitle]?.status == undefined || context?.[nodeTitle].status == 0) ? '' : (context?.[nodeTitle]?.di > 0 ? 'off' : 'on')) + ((context?.[nodeTitle]?.alert == 1) && context?.alert ? ' bling' : '')" :data-title="nodeTitle" :style="nodeStyle">
      <lay-badge type="dot" color="rgb(30, 159, 255)" ripple style="left: 0rem;top: -0.31rem;" v-if="false"></lay-badge>
    </div>
    <template #content>
      <lay-dropdown-menu>
        <lay-dropdown-menu-item disabled>
          <template #default>
           <p style="text-align: center;cursor: default;color: #3FA7FF;font-size: 13px;letter-spacing: 1px;width: 300px">
             <lay-button border="green" border-style="dashed" type="default" size="xs" fluid  @click="viewNodeChart({name: `【${context?.[nodeTitle]?.cabinet_no}】${context?.[nodeTitle]?.cabinet_name}`, location: context?.[nodeTitle]?.location, ct: context?.[nodeTitle]?.ct,  type: context?.[nodeTitle]?.type})">
               <span style="padding: 0 10px"><lay-icon type="layui-icon-chart" ></lay-icon></span>
               <span style="" :title="info">
              【{{nodeTitle.replaceAll("D", '')}}】{{info}}
            </span><br/>
             </lay-button>
           </p>
          </template>
        </lay-dropdown-menu-item>
        <lay-dropdown-menu-item disabled>
          <template #default>
            <span style="color: #3FA7FF;font-size: 13px;letter-spacing: 1px;width: 300px;display: inline-block;cursor: default;" :title="info">
              <lay-table size="sm" :columns="cols" :data-source="[
                  {key: 'CT变比', value: context?.[nodeTitle]?.ct},
                  {key: '平均相电压', value: context?.[nodeTitle]?.u},
                  {key: '平均线电压', value: context?.[nodeTitle]?.ux},
                  {key: 'A相电流', value: context?.[nodeTitle]?.ia},
                  {key: 'B相电流', value: context?.[nodeTitle]?.ib},
                  {key: 'C相电流', value: context?.[nodeTitle]?.ic},
                  {key: '平均电流', value: context?.[nodeTitle]?.i},
                  {key: '有功功率', value: context?.[nodeTitle]?.p},
                  {key: '无功功率', value: context?.[nodeTitle]?.q},
                  {key: '功率因数', value: context?.[nodeTitle]?.pf},
                  {key: '有功电能', value: context?.[nodeTitle]?.w},
                  {key: '开关位置', value: (context?.[nodeTitle]?.status == undefined || context?.[nodeTitle].status == 0) ? '--' : (context?.[nodeTitle]?.di > 0 ? '合位' : '分位') },
                  {key: '数据更新时间', value: context?.[nodeTitle]?.now},

                  ]"></lay-table>
            </span>
          </template>
        </lay-dropdown-menu-item>
        <lay-dropdown-menu-item @click="delayService" v-if="false">
          <template #prefix><lay-icon type="layui-icon-set-fill" class="layui-anim layui-anim-rotate layui-anim-loop"></lay-icon></template>
          <template #default><span>检修标注</span></template>
        </lay-dropdown-menu-item>
        <lay-dropdown-sub-menu v-if="false">
          <template #prefix><lay-icon type="layui-icon-app"></lay-icon></template>
          <template #default>遥控操作</template>
          <template #content>
            <lay-dropdown-menu-item >
              <template #prefix>&nbsp;</template>
              <template #default>开闸</template>
              <template #suffix><span style="margin-left: 50px; font-size:10px">&nbsp;</span></template>
            </lay-dropdown-menu-item>
            <lay-dropdown-menu-item >
              <template #prefix>&nbsp;</template>
              <template #default>合闸</template>
              <template #suffix><span style="font-size:10px">&nbsp;</span></template>
            </lay-dropdown-menu-item>
          </template>
        </lay-dropdown-sub-menu>



        <lay-line margin="5px" theme="#EEE" v-if="false"></lay-line>
        <lay-dropdown-menu-item disabled v-if="false">
          <template #prefix><lay-icon type="layui-icon-about"></lay-icon></template>
          <template #default>更多</template>
          <template #suffix><lay-icon type="layui-icon-right"></lay-icon></template>
        </lay-dropdown-menu-item>
      </lay-dropdown-menu>
    </template>
  </lay-dropdown>
</template>

<script setup>
import {defineProps} from "vue";
import {layer} from "@layui/layui-vue";
import {useRouter} from "vue-router/dist/vue-router";
const router = useRouter()
defineProps(['nodeTitle', 'nodeStyle', 'info', 'type', 'context','remark'])
const delayService = () => {
  layer.confirm("你如何看待 layui-vue 的发布", {btn: [{text:'站着看'},{text:'坐着看'}]});
}

const cols = [
  {
    title:"数据项",
    width:"120px",
    key:"key"
  },
  {
    title:"值",
    width:"160px",
    key:"value",
    ellipsisTooltip: true,
  }
]
function viewNodeChart(node){
  if (node.location){
    router.push({path: '/7-1', query: node})
  }
}
</script>

<style scoped>
.on-off{
  position: absolute;
  cursor: pointer;
  width: 10px;
  height: 21px;
  background-color: #FF2929;
}
.control-status{
  cursor: default;
  /*position: absolute;*/
  margin-left: 25px;
  margin-top: -5px;
  /*bottom: -13px;*/
  font-size: 13px;
  bottom: 0px;
  color: #FFF;
  font-size: 12px;
  background-color: #3FA7FF;
  display: inline-block;
  width: 20px;
  text-align: center;
  padding: 5px 0px;
  border-radius: 2px;
}
.service{
  position: absolute;
  left: -8px;
  bottom: -3px;
  color: #24EBA4;
}
.desc{
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
}
.signal-node{
  position: absolute;
  width: 0.55rem;
  height: 0.625rem;
  background-color: #ACACAC;
  cursor: pointer;

}
.on{
  background-color: rgb(0, 255, 0);
}
.off{
  background-color: #FF2929;
}
.signal-node.fa-no-signal{
  opacity: 0.2;
}

</style>